import { Http } from '../../common/api';
import { ProductCatalogueApiConfiguration } from '../models';

export const productCatalogueHttp = new Http();

export const initializeProductCatalogueHttp = (config: ProductCatalogueApiConfiguration): void => {
  const headers = config.apiKey ? { api_key: config.apiKey } : undefined;
  productCatalogueHttp.initializeHttp(config.baseUrl, headers);
};

export const isProductCatalogueApiConfigured = (): boolean => {
  return productCatalogueHttp.isReady();
};
